import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { GA_EVENTS, GA_PROPS } from 'src/app/core/const.variables';
import { HelperService } from 'src/app/core/services/helper.service';
import { opacityInOut } from 'src/app/shared/animations/opacity-in-out.animation';
import { scaleInOut } from 'src/app/shared/animations/scale-in-out.animation';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'share-popup',
  templateUrl: 'share-popup.component.html',
  styleUrls: ['share-popup.component.scss'],
  animations: [ opacityInOut, scaleInOut ]
})
export class SharePopupComponent implements OnInit {

  @Input() set shareUrl(val) {
    this.url = getWindow().location.origin + '/sl/' + val;
  };
  @Output() onClose = new EventEmitter<any>();
  url = null;
  copied = false;

  constructor(private gaService: GoogleAnalyticsService, private helperService: HelperService) {
  }

  ngOnInit(): void {
    this.helperService.blockScroll$.next(true);
  }

  close() {
    this.helperService.blockScroll$.next(false);
    this.onClose.emit();
  }

  share(source) {
    this.gaService.gtag('event', GA_EVENTS.WasShared, {
      [GA_PROPS.SharedUrl]: this.url,
      [GA_PROPS.SharedSource]: source,
    });
  }

  wasCopied() {
    this.copied = true;
    this.share('copy');
    setTimeout(() => this.copied = false, 3000);
  }

}
